// third-party
import { FormattedMessage } from 'react-intl';

// assets
import { IconUserCheck, IconBasket, IconMessages, 
    IconLayoutKanban, IconMail, IconCalendar, 
    IconNfc, IconReport,
    IconCashBanknote
} from "@tabler/icons-react"

// constant
const icons = {
    IconUserCheck,
    IconBasket,
    IconMessages,
    IconLayoutKanban,
    IconMail,
    IconCalendar,
    IconNfc
};

// ==============================|| APPLICATION MENU ITEMS ||============================== //

const caisse = {
    id: 'caisse',
    title: [ "I. ", <FormattedMessage id="gestion_caisse" />],
    type: 'group',
    icon: <IconCashBanknote />, // Use a valid icon component here

   /*  children: [
        {
            id: 'caisse',
            title:<FormattedMessage id="mouvement_caisse" />,
            type: 'collapse',
            icon: IconReport, */
            children: [
                {
                    id: 'caisse_jour',
                    title: ["1. ",  <FormattedMessage id="mouvements_du_jour" />],
                    type: 'item',
                    url: '/caisse/CaisseDuJour'
                },

                {
                    id: 'mouvement_operador',
                    title: ["2. ", <FormattedMessage id="mouvement_por_operador" />],
                    type: 'item',
                    url: '/caisse/CaisseOperateur'
                },
                {
                    id: 'caisseRechercheEtudiant',
                    title: ["3. ", <FormattedMessage id="mouvement_caisse_etudiant" />],
                    type: 'item',
                    url: '/caisse/CaisseOperateurEtudiant'
                },
                {
                    id: 'mouvementParTypePaiement1',
                    title: ["4. ",<FormattedMessage id="mouvement_par_type_paiement" />],
                    type: 'item',
                    url: '/caisse/CaisseParTypePaiement'
                },
                {
                    id: 'caisse__par__type__paiement1',
                    title: ["5. ", <FormattedMessage id="caisse__par__type__paiement" />],
                    type: 'item',
                    url: '/caisse/CaisseParTypePaiementConfigurado'
                },

                {
                    id: 'caisse_jour_fonctionnement_user1',
                    title: ["6. ", <FormattedMessage id="caisse_jour_fonctionnement_user" />],
                    type: 'item',
                    url: '/caisse/WorkingDaysUser'
                }


                

                
            ]
    //    }
   // ]
};

export default caisse;
